import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {ThingsService} from '../things.service';
import {ThingModel} from '../model/Ithing.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NotificationBarService} from '../../core/notify/notification.service';
import {NotificationType} from '../../core/notify/index';
import {Title} from '@angular/platform-browser';
import {GlobalService} from '../../global/global.service';

@Component({
  selector: 'app-things-details',
  templateUrl: './things-details.component.html',
  styleUrls: ['./things-details.component.scss']
})
export class ThingsDetailsComponent implements OnInit {
  thing: ThingModel = new ThingModel();
  id: number;
  defaultConnection: any;
  isDetailsLoading: boolean;
  isDescriptionEdit = false;
  tagEdit = false;
  isConnectionUpdated = false;
  form: FormGroup;
  isEventLoading = true;
  selectedConnection;
  isEdit;
  isSimulate;
  isEvent;
  schema = {};
  eventData = {};
  errors = {tags: '' };
  copied = false;
  nameEdit = false;
  isHideSimulateButton: boolean;

  @ViewChild('clonePopup') clonePopup;
  @ViewChild('previewPopup') previewPopup;
  @ViewChild('eventPopup') eventPopup;
  @ViewChild('confirm') confirm;

  constructor(
    private activatedRoute: ActivatedRoute,
    private thingService: ThingsService,
    private fb: FormBuilder,
    private notifier: NotificationBarService,
    private thingsService: ThingsService,
    private router: Router
  ) { }

  ngOnInit() {
    this.isDetailsLoading = true;
    this.activatedRoute.params
      .subscribe((params: Params) => {
        let thingId = params['id'];
        this.fetchThingDetails(thingId);
      });
    this.buildForm();
    this.thingService.getThingCreateSubject()
      .subscribe((response) => {
      this.thing = response.thing;
    });
  }

  buildForm() {


    this.form = this.fb.group({
      'description': ['', [
        Validators.maxLength(250),

      ]
      ],
      'tags': ['', [

      ]
    ]});
    this.form.controls['description'].disable();
  }

  selectConnection(connection) {
      this.selectedConnection = connection;
      this.isConnectionUpdated = true;
    }

  editDescription() {
    this.form.controls['description'].enable();
    this.isDescriptionEdit = true;
  }

  cancelEdit() {
    this.form.controls['description'].setValue(this.thing.description);
    this.form.controls['description'].disable();
    this.isDescriptionEdit = false;
    this.tagEdit = false;
    this.isConnectionUpdated = false;

  }

  showSimulateWindow() {
    this.isSimulate = true;
    this.isHideSimulateButton = true;
  }

  hideSimulationWindow() {
    this.isSimulate = false;
    this.isHideSimulateButton = false;
  }

  fetchThingDetails(thingId: number) {
      this.thingService.getThingDetails(thingId, {nonce: new Date().getTime()})
        .subscribe((response) => {
          this.thing = response;
          this.form.setValue({description: this.thing.description, tags: ''});
          this.defaultConnection = this.thing.connection;
          this.isConnectionUpdated = false;
          this.thingService.getSchemaMappedToThing(this.thing)
            .subscribe((response) => {
              this.isDetailsLoading = false;
              this.schema = response.data;
              this.eventData = this.thingService.getEventData(this.thing, this.schema);
             // this.eventPopup.open(this.simulationSchema);
            }, () => { this.isDetailsLoading = true; });

        }, () => {this.eventPopup.stopLoader(); this.isDetailsLoading = true; });
  }
  addTag(tag) {
    let t = tag;
    if (tag.length > 50) {
      this.errors.tags = 'ONBOARD_THING.VALIDATIONS.DESCRIBE_THING.TAGS.MAX_LENGTH';
      return;
    }
    if (this.thing.tags.indexOf(tag.trim()) > -1 || tag.trim().length < 1) {
      return;
    }
    this.thing.tags.push(tag.trim());
    this.form.controls['tags'].reset();
    this.thingService.addTag(tag.trim())
      .subscribe( () => {});
  }


  removeTag(tag) {
    let idx = this.thing.tags.indexOf(tag);
    this.thing.tags.splice(idx, 1);
  }

  updateThingName(name) {
    if (!name) {
      this.nameEdit = false;
      this.isEdit = false;
      return;
    }
    if (name.length > 50) {
      this.notifier.create({message: 'ONBOARD_THING.VALIDATIONS.DESCRIBE_THING.NAME.MAX_LENGTH',
        type: NotificationType.Error});
      return;
    }

    this.nameEdit = true;
    this.thing.name = name;
    this.thingService.updateThing(this.thing)
      .subscribe((response) => {
          this.nameEdit = false;
          this.thing = response.data;
          this.isEdit = false;
          this.notifier.create({message: response.status.message, type: NotificationType.Success});
        },
        (error) => {
          this.nameEdit = false;
        });
  }

  updateThing(name) {
    if (this.form.controls['description'].value.toString().length > 250) {
      this.notifier.create({message: 'ONBOARD_THING.VALIDATIONS.DESCRIBE_THING.DESCRIPTION.MAX_LENGTH',
        type: NotificationType.Error});
      return;
    }
    this.isDetailsLoading = true;
    this.thing.connection.id = this.selectedConnection? this.selectedConnection.id : this.defaultConnection.id;
    this.thing.connection.name = this.selectedConnection ? this.selectedConnection.protocolName : this.defaultConnection.protocolName;
    this.thing.description = this.form.controls['description'].value;

    this.thingService.updateThing(this.thing)
       .subscribe((response) => {
          this.isDetailsLoading = false;
          this.thing = response.data;
          this.notifier.create({message: response.status.message, type: NotificationType.Success});
          this.cancelEdit();
       },
         (error) => {
           this.isDetailsLoading = false;
         });
  }

  cloneThing(response) {
        this.notifier.create({message: response.status.message, type: NotificationType.Success});
        this.isDetailsLoading = false;
        this.clonePopup.close();

  }

  open() {
    this.clonePopup.open();
  }

  openPreview() {
      this.previewPopup.open();
  }

  openConfirmPopup() {
    this.confirm.open();
  }

  closeConfirmPopup() {
    this.confirm.close();
  }
  confirmDelete(isConfirmation) {
    if (!isConfirmation) {
      this.confirm.close();
      return;
    }

    this.deleteThing();
  }
  private deleteThing() {
    this.isDetailsLoading  = true;
    this.thingsService.deleteThingMiddleware(this.thing)
      .subscribe((response) => {
          this.confirm.close();
          this.isDetailsLoading = false;
          this.notifier.create({message: response.status.message, type: NotificationType.Success});
          this.router.navigate(['/things']);
        },
        (error) => {
          this.isDetailsLoading = false;
          this.confirm.close();
        });
  }

  onNewEvent(event) {
     this.thing.lastReportedTime = event.timestamp;
     this.thing.online = true;
     this.isEvent = event;
  }
  onEventLoaded(event) {
    this.isEventLoading = false;
  }
  onThingUpdate(event) {
    this.thing.online = event.online;
  }

  hideSimulateButton() {
    this.isHideSimulateButton = true;
  }


}



// WEBPACK FOOTER //
// ./src/app/things/things-details/things-details.component.ts